import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/layouts/default.vue").then(m => m.default || m)),
  error: defineAsyncComponent(() => import("/root/workspace/__flow_work/__flow_builds/38f3eaf9-c090-40f7-aa5b-0f199cdabb58/workspace/my_repo/app/layouts/error.vue").then(m => m.default || m))
}